export default "/static/webpack/media/check-icon-dark.54218442.svg";